import ct1 from '@/assets/img/home-v1/pdct-cgry-01.jpg'
import ct2 from '@/assets/img/home-v1/pdct-cgry-02.jpg'
import ct3 from '@/assets/img/home-v1/pdct-cgry-03.jpg'

import shop1 from '@/assets/img/gallery/shop-01/shop-01.jpg'
import shop2 from '@/assets/img/gallery/shop-01/shop-02.jpg'
import shop3 from '@/assets/img/gallery/shop-01/shop-03.jpg'
import shop4 from '@/assets/img/gallery/shop-01/shop-04.jpg'
import shop5 from '@/assets/img/gallery/shop-01/shop-05.jpg'
import shop6 from '@/assets/img/gallery/shop-01/shop-06.jpg'
import shop7 from '@/assets/img/gallery/shop-01/shop-07.jpg'
import shop8 from '@/assets/img/gallery/shop-01/shop-08.jpg'
import shop9 from '@/assets/img/gallery/shop-01/shop-09.jpg'
import shop10 from '@/assets/img/gallery/shop-01/shop-10.jpg'

import fea1 from '@/assets/img/svg/fea-1.svg'
import fea2 from '@/assets/img/svg/fea-2.svg'
import fea3 from '@/assets/img/svg/fea-3.svg'
import fea4 from '@/assets/img/svg/fea-4.svg'
import fea5 from '@/assets/img/svg/fea-5.svg'

import blog1 from '@/assets/img/shortcode/blog/blog-22.jpg'
import blog2 from '@/assets/img/shortcode/blog/blog-23.jpg'
import blog3 from '@/assets/img/shortcode/blog/blog-24.jpg'
import blog4 from '@/assets/img/shortcode/blog/blog-25.jpg'
import blog5 from '@/assets/img/shortcode/blog/blog-26.jpg'
import blog6 from '@/assets/img/shortcode/blog/blog-27.jpg'
import blog7 from '@/assets/img/shortcode/blog/blog-28.jpg'
import blog8 from '@/assets/img/shortcode/blog/blog-29.jpg'

import blog01 from '@/assets/img/home-v2/blog-01.jpg'
import blog02 from '@/assets/img/home-v2/blog-02.jpg'
import blog03 from '@/assets/img/home-v2/blog-03.jpg'

import partner1 from '@/assets/img/partner/partner-1.svg'
import partner2 from '@/assets/img/partner/partner-2.svg'
import partner3 from '@/assets/img/partner/partner-3.svg'
import partner4 from '@/assets/img/partner/partner-4.svg'
import partner5 from '@/assets/img/partner/partner-5.svg'
import partner6 from '@/assets/img/partner/partner-6.svg'
import partner7 from '@/assets/img/partner/partner-7.svg'
import partner8 from '@/assets/img/partner/partner-8.svg'
import partner9 from '@/assets/img/partner/partner-9.svg'
import partner10 from '@/assets/img/partner/partner-10.svg'
import partner11 from '@/assets/img/partner/partner-11.svg'
import partner12 from '@/assets/img/partner/partner-12.svg'
import partner13 from '@/assets/img/partner/partner-13.svg'
import partner14 from '@/assets/img/partner/partner-14.svg'
import partner15 from '@/assets/img/partner/partner-15.svg'

import partner01 from '@/assets/img/partner/partner-light-1.svg'
import partner02 from '@/assets/img/partner/partner-light-2.svg'
import partner03 from '@/assets/img/partner/partner-light-3.svg'
import partner04 from '@/assets/img/partner/partner-light-4.svg'
import partner05 from '@/assets/img/partner/partner-light-5.svg'
import partner06 from '@/assets/img/partner/partner-light-6.svg'
import partner07 from '@/assets/img/partner/partner-light-7.svg'
import partner08 from '@/assets/img/partner/partner-light-8.svg'
import partner09 from '@/assets/img/partner/partner-light-9.svg'
import partner010 from '@/assets/img/partner/partner-light-10.svg'
import partner011 from '@/assets/img/partner/partner-light-11.svg'
import partner012 from '@/assets/img/partner/partner-light-12.svg'
import partner013 from '@/assets/img/partner/partner-light-13.svg'
import partner014 from '@/assets/img/partner/partner-light-14.svg'
import partner015 from '@/assets/img/partner/partner-light-15.svg'

import product1 from '@/assets/img/home-v2/product/pdct-01.jpg'
import product2 from '@/assets/img/home-v2/product/pdct-02.jpg'
import product3 from '@/assets/img/home-v2/product/pdct-03.jpg'
import product4 from '@/assets/img/home-v2/product/pdct-04.jpg'

import team2 from '@/assets/img/testimonial/tmnl-02.jpg'
import team3 from '@/assets/img/testimonial/tmnl-03.jpg'

import team01 from '@/assets/img/team/team-01.jpg'
import team02 from '@/assets/img/team/team-02.jpg'
import team03 from '@/assets/img/team/team-03.jpg'
import team04 from '@/assets/img/team/team-04.jpg'
import team05 from '@/assets/img/team/team-05.jpg'
import team06 from '@/assets/img/team/team-06.jpg'

import cart1 from '@/assets/img/gallery/cart/cart-01.jpg'
import cart2 from '@/assets/img/gallery/cart/cart-02.jpg'
import cart3 from '@/assets/img/gallery/cart/cart-03.jpg'
import cart4 from '@/assets/img/gallery/cart/cart-04.jpg'
import cart5 from '@/assets/img/gallery/cart/cart-05.jpg'

import shop01 from '@/assets/img/gallery/shop-04/shop-01.jpg'
import shop02 from '@/assets/img/gallery/shop-04/shop-02.jpg'
import shop03 from '@/assets/img/gallery/shop-04/shop-03.jpg'
import shop04 from '@/assets/img/gallery/shop-04/shop-04.jpg'
import shop05 from '@/assets/img/gallery/shop-04/shop-05.jpg'
import shop06 from '@/assets/img/gallery/shop-04/shop-06.jpg'
import shop07 from '@/assets/img/gallery/shop-04/shop-07.jpg'
import shop08 from '@/assets/img/gallery/shop-04/shop-08.jpg'
import shop09 from '@/assets/img/gallery/shop-04/shop-09.jpg'

export const categoryOne = [
    {
        image:ct1,
        item:'5 items',
        name:'New Seat Tools'
    },
    {
        image:ct2,
        item:'13 items',
        name:'New Seat Tools'
    },
    {
        image:ct3,
        item:'23 items',
        name:'New Seat Tools'
    },
    {
        image:ct1,
        item:'5 items',
        name:'New Seat Tools'
    },
    {
        image:ct2,
        item:'13 items',
        name:'New Seat Tools'
    },
    {
        image:ct3,
        item:'23 items',
        name:'New Seat Tools'
    },
    
]

export const productList = [
    {
        id:1,
        image:shop1,
        tag:'Hot Sale',
        price:'$25.75',
        name:'White Minimal Chair'
    },
    {
        id:2,
        image:shop2,
        tag:'NEW',
        price:'$122.75',
        name:'Preminu Luxury Sofa'
    },
    {
        id:3,
        image:shop3,
        tag:'10% OFF',
        price:'$140.99',
        name:'Table With Pops'
    },
    {
        id:4,
        image:shop4,
        tag:'',
        price:'$122.75',
        name:'Luxury Lamp for Wall'
    },
    {
        id:5,
        image:shop5,
        tag:'Hot Sale',
        price:'$140.99',
        name:'White Minimal Chair'
    },
    {
        id:6,
        image:shop6,
        tag:'',
        price:'$122.75',
        name:'Luxury Vase for Table'
    },
    {
        id:7,
        image:shop7,
        tag:'',
        price:'$122.75 - $140.99',
        name:'New Modern Luxury Table with Pops Lorem ipsum Furniture'
    },
    {
        id:8,
        image:shop8,
        tag:'10% OFF',
        price:'$122.75',
        name:'Modern Logn Table'
    },
    {
        id:9,
        image:shop9,
        tag:'',
        price:'$122.75',
        name:'Luxury Lamp for Wall'
    },
    {
        id:10,
        image:shop10,
        tag:'',
        price:'$122.75',
        name:'Luxury Lamp for Wall'
    },
    {
        id:11,
        image:shop1,
        tag:'',
        price:'$122.75',
        name:'Luxury Lamp for Wall'
    },
    {
        id:12,
        image:shop2,
        tag:'',
        price:'$122.75',
        name:'White Minimal Chair'
    },
]

export const featureOne = [
    {
        id:1,
        image:fea1,
        title:'Free Shipping',
        desc:'Enjoy free shipping on all orders, making your shopping experience even more convenient. Get your favorite products delivered.'
    },
    {
        id:2,
        image:fea2,
        title:'Easy to Return',
        desc:`Experience hassle-free returns with our easy-to-use return policy. If you're not satisfied, simply return your product for a quick.`
    },
    {
        id:3,
        image:fea3,
        title:'Secure Payment',
        desc:`Shop with confidence using our secure payment options, ensuring your personal information stays protected. We prioritize your safety.`
    },
    {
        id:4,
        image:fea4,
        title:`Customer Support`,
        desc:`Our dedicated customer support team is here to assist you every step of the way. Reach out to us anytime for prompt, friendly help.`
    },
    {
        id:5,
        image:fea5,
        title:`Product QC Team`,
        desc:`Our meticulous product QC team ensures every item meets our highest standards. Trust in quality assurance that goes beyond expectation.`
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog2,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:3,
        image:blog3,
        date:'29th Nov 2025',
        tag:'Vases',
        title:`Small Space, Big Style: Room Decor Solutions from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:4,
        image:blog4,
        date:'13th March 2025',
        tag:'Interior',
        title:`Innovative Room Decor: Unleashing Creativity with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:5,
        image:blog5,
        date:'5th May 2025',
        tag:'Chair',
        title:`Timeless Elegance: Classic Room Decor Ideas from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:6,
        image:blog6,
        date:'19th June 2025',
        tag:'Sofa',
        title:`Budget-Friendly Brilliance: Room Decor Hacks by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:7,
        image:blog7,
        date:'20th June 2025',
        tag:'Vases',
        title:`Personalize Your Space: Custom Room Decor Options with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:8,
        image:blog8,
        date:'31st Aug 2025',
        tag:'Lamp',
        title:`ransform Your Home: Room Decor Tips and Trends with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
]

export const partnerData = [
    {
        image:partner1,
        image2:partner01
    },
    {
        image:partner2,
        image2:partner02
    },
    {
        image:partner3,
        image2:partner03
    },
    {
        image:partner4,
        image2:partner04
    },
    {
        image:partner5,
        image2:partner05
    },
    {
        image:partner6,
        image2:partner06
    },
    {
        image:partner8,
        image2:partner08
    },
]

export const productSlider = [
    {
        image:product1,
        name:'Luxury Sofa Set',
        product:'26 Products'
    },
    {
        image:product2,
        name:'Table & Chair',
        product:'40 Products'
    },
    {
        image:product3,
        name:'Vases & Lamp',
        product:'14 Products'
    },
    {
        image:product4,
        name:'Interior Collection',
        product:'32 Products'
    },
    {
        image:product1,
        name:'Luxury Sofa Set',
        product:'26 Products'
    },
    {
        image:product2,
        name:'Table & Chair',
        product:'40 Products'
    },
]

export const teamData = [
    {
        image:team2,
        name:'Jennifer Smith',
        location:'Berminghum ,UK',
        desc:`Furnixar exceeded my expectations with their exceptional furniture pieces. The quality craftsmanship and attention to detail truly shine through in every product. My home has been transformed into a stylish sanctuary thanks to Furnixar!`
    },
    {
        image:team3,
        name:'Jennifer Smith',
        location:'Berminghum ,UK',
        desc:`Furnixar exceeded my expectations with their exceptional furniture pieces. The quality craftsmanship and attention to detail truly shine through in every product. My home has been transformed into a stylish sanctuary thanks to Furnixar!`
    },
]
export const blogTwoData = [
    {
        id:1,
        image:blog01,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog02,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:3,
        image:blog03,
        date:'29th Nov 2025',
        tag:'Vases',
        title:`Small Space, Big Style: Room Decor Solutions from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:1,
        image:blog01,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog02,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
]

export const pricingData = [
    {
        title:'Basic Plan',
        month:'$9',
        year:'$99',
        feature:[
            'Access one person',
            'Get access to 230+ Product',
            'Advance Security System'
        ]
    },
    {
        title:'Standard Plan',
        month:'$19',
        year:'$199',
        feature:[
            'Access two person.',
            'Get access to 230+ Product',
            'Advance Security System'
        ]
    },
    {
        title:'Premium Plan',
        month:'$99',
        year:'$999',
        feature:[
            'Access five person',
            'Get access to 230+ Product',
            'Advance Security System',
            'Buy one time get life time access',
            'Lorem ipsum dolor sit amet.'
        ]
    },
]

export const teamDataTwo = [
    {
        image:team01,
        name:'Luciana Sacchena',
        position:'Product Designer',
        desc:'Product designers are the creative architects behind the innovative solutions that shape our world.',
        class1:'order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2',
        delay:'100'
    },
    {
        image:team02,
        name:'Jamse Zuan',
        position:'CEO & Founder',
        desc:'As the visionary leader of our furniture eCommerce business, Emma Wilson ensures the overall strategic direction and growth of the company.',
        class1:'order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1',
        delay:'200'
    },
    {
        image:team03,
        name:'Flacxia Piano',
        position:'Interior Designer',
        desc:'Flacxia Piano ensures smooth daily operations and efficient logistics management. With his expertise in streamlining processes, he helps maintain a seamless supply chain',
        class1:'order-1 lg:order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2 lg:order-1',
        delay:'300'
    },
    {
        image:team04,
        name:'Luciana Sacchena',
        position:'Photographer',
        desc:'Luciana Sacchena oversees daily operations and ensures the seamless execution of business processes. With a keen eye for logistics and a strong background',
        class1:'order-2 lg:order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1 lg:order-2',
        delay:'400'
    },
    {
        image:team05,
        name:'Nathan',
        position:'Client Communication Executive',
        desc:'PAs the technical lead, Nathan ensures our website is always fast, secure, and user-friendly. He leads the development team in creating an optimized shopping experience for every visitor.',
        class1:'order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2',
        delay:'500'
    },
    {
        image:team06,
        name:'Porlo Matiana',
        position:'Marketing Specialist',
        desc:'Porlo Matiana heads our sales team, using his expertise to meet customer needs with personalized furniture recommendations. His leadership boosts our sales growth while ensuring customer satisfaction.',
        class1:'order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1',
        delay:'600'
    },
]

export const partnerDataTwo = [
    {
        image:partner1,
        image2:partner01,
        delay:'100'
    },
    {
        image:partner2,
        image2:partner02,
        delay:'200'
    },
    {
        image:partner3,
        image2:partner03,
        delay:'300'
    },
    {
        image:partner4,
        image2:partner04,
        delay:'400'
    },
    {
        image:partner5,
        image2:partner05,
        delay:'500'
    },
    {
        image:partner6,
        image2:partner06,
        delay:'600'
    },
    {
        image:partner7,
        image2:partner07,
        delay:'700'
    },
    {
        image:partner8,
        image2:partner08,
        delay:'800'
    },
    {
        image:partner9,
        image2:partner09,
        delay:'900'
    },
    {
        image:partner10,
        image2:partner010,
        delay:'1000'
    },
    {
        image:partner11,
        image2:partner011,
        delay:'1100'
    },
    {
        image:partner12,
        image2:partner012,
        delay:'1200'
    },
    {
        image:partner13,
        image2:partner013,
        delay:'1300'    
    },
    {
        image:partner14,
        image2:partner014,
        delay:'1400'
    },
    {
        image:partner15,
        image2:partner015,
        delay:'1500'
    },
]

export const cartData = [
    {
        image:cart1,
        tag:'Chair',
        name:'Modern Sofa Set',
        price:'$74',
        status:'Completed'
    },
    {
        image:cart2,
        tag:'Interior',
        name:'Classic Chair with Vase',
        price:'$34',
        status:'Pending'
    },
    {
        image:cart3,
        tag:'Light',
        name:'Luxury Hanging Lamp',
        price:'$33',
        status:'Cancel'
    },
    {
        image:cart4,
        tag:'Lamp',
        name:'Premium Quality Vase',
        price:'$48',
        status:'Completed'
    },
    {
        image:cart5,
        tag:'Interior',
        name:'Classic White Chair',
        price:'$88',
        status:'Completed'
    },
]

export const productListTwo = [
    {
        id:1,
        image:shop01,
        offer:true,
        price:'$122.75',
        category:['Interior'],
        name:'Classic Table Lamp'
    },
    {
        id:2,
        image:shop02,
        offer:false,
        price:'$122.75',
        category:['Table'],
        name:'Classic Table Lamp'
    },
    {
        id:3,
        image:shop03,
        offer:true,
        price:'$122.75',
        category:['Interior', 'Vase',],
        name:'Classic Table Lamp'
    },
    {
        id:4,
        image:shop04,
        offer:false,
        price:'$122.75',
        category:['Table', 'Design'],
        name:'Classic Table Lamp'
    },
    {
        id:5,
        image:shop05,
        offer:true,
        price:'$122.75',
        category:['Table'],
        name:'Classic Table Lamp'
    },
    {
        id:6,
        image:shop06,
        offer:false,
        price:'$122.75',
        category:['Vase'],
        name:'Classic Table Lamp'
    },
    {
        id:7,
        image:shop07,
        offer:false,
        price:'$122.75',
        category:['Table', 'Design'],
        name:'Classic Table Lamp'
    },
    {
        id:8,
        image:shop08,
        offer:false,
        price:'$122.75',
        category:['Vase'],
        name:'Classic Table Lamp'
    },
    {
        id:9,
        image:shop09,
        offer:false,
        price:'$122.75',
        category:[ 'Design'],
        name:'Classic Table Lamp'
    },
]

export const productTag = [
    'Chair',
    'Art & Paint',
    'Mirror',
    'Table',
    'Lamp'
]

export const venderInfo = [
    {
        name:'John Furniture House',
        vendor:'John Smith Doe',
        shop:'West New York, NY, 1234589',
        mail:'johnmsmith@gmail.com',
        call:'+11 - 01234 5678'
    },
    {
        name:'Furniture Gallery',
        vendor:'John Smith Doe',
        shop:'West New York, NY, 1234589',
        mail:'johnmsmith@gmail.com',
        call:'+11 - 01234 5678'
    },
]

export const detailReview = [
    {
        name:'Merlina Quexy',
        desc:`Furnixar's products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
    {
        name:'Merlina Quexy',
        desc:`Furnixar's products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
    {
        name:'Merlina Quexy',
        desc:`Furnixar's products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
]

export const shippingAbout = [
    {
        title:'For Shipping',
        desc:`Shipping times may vary based on your location and the selected delivery option. Please review our shipping policies for details on processing times, charges, and tracking updates. Contact us for any shipping-related inquiries or assistance.`
    },
    {
        title:'Item Return',
        desc:`We offer a hassle-free process to ensure your satisfaction. Please review our return policy for eligibility and steps to initiate a return. we offer a hassle-free process to ensure your satisfaction. Please review our return policy for eligibility and steps to initiate a return.`
    },
    {
        title:'Accepted Problem Issue',
        desc:`Choose from multiple methods, including credit cards, debit cards, and online payment gateways. All transactions are encrypted to ensure your information remains safe. For any payment-related concerns, our support team is here to assist.`
    },
]
